import { useState } from 'react';
import AdminLayout from '@/components/feature/AdminLayout';
import { adminUsers } from '@/mocks/transactions';

export default function AdminUsers() {
  const [search, setSearch] = useState('');
  const filtered = adminUsers.filter((u) => u.name.toLowerCase().includes(search.toLowerCase()) || u.email.toLowerCase().includes(search.toLowerCase()));

  return (
    <AdminLayout>
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
          <div>
            <h1 className="text-2xl font-bold text-foreground-950">Quản lý người dùng</h1>
            <p className="text-foreground-600 text-sm mt-1">Tổng {adminUsers.length} người dùng</p>
          </div>
          <div className="relative w-full sm:w-72">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Tìm theo tên hoặc email..." className="w-full pl-9 pr-4 py-2.5 rounded-md bg-background-100 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-accent-500" />
          </div>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/60">
          <table className="w-full text-sm min-w-[760px]">
            <thead>
              <tr className="bg-background-100 text-left">
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Người dùng</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Số dư</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">KYC</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Trạng thái</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Tham gia</th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600 text-right">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((u) => (
                <tr key={u.id} className="border-t border-background-200/40 hover:bg-background-100/60 transition-colors">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-primary-500/20 flex items-center justify-center">
                        <span className="text-sm font-bold text-primary-400">{u.name.split(' ').map((w) => w[0]).slice(0, 2).join('')}</span>
                      </div>
                      <div>
                        <p className="font-semibold text-foreground-950 whitespace-nowrap">{u.name}</p>
                        <p className="text-xs text-foreground-600">{u.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3 font-semibold text-foreground-900 whitespace-nowrap">{u.balance.toLocaleString('vi-VN')}đ</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${
                      u.kyc === 'verified' ? 'bg-emerald-500/15 text-emerald-400' : u.kyc === 'pending' ? 'bg-accent-500/15 text-accent-400' : 'bg-rose-500/15 text-rose-400'
                    }`}>
                      {u.kyc === 'verified' ? 'Đã xác minh' : u.kyc === 'pending' ? 'Chờ duyệt' : 'Từ chối'}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${u.status === 'active' ? 'bg-emerald-500/15 text-emerald-400' : 'bg-rose-500/15 text-rose-400'}`}>
                      {u.status === 'active' ? 'Hoạt động' : 'Đã khóa'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{u.joined}</td>
                  <td className="px-4 py-3 text-right">
                    <button className="px-3 py-1.5 rounded-md border border-background-300/60 text-xs font-semibold text-foreground-700 hover:border-accent-500 hover:text-accent-400 whitespace-nowrap cursor-pointer transition-colors">
                      Xem chi tiết
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}